import { useQuery } from '@tanstack/react-query'

import { getTeams } from 'common/api/teamsApi'
import { contentKeys } from 'features/unifiedFlow/api/queryKeys'

const useFetchTeams = (accountId: string) => {
  const { data: teams, isLoading } = useQuery(
    contentKeys.teams(accountId),
    () => getTeams(accountId)
  )

  return { data: teams?.data, isLoading }
}

export default useFetchTeams
